module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Devices/Gameboy-08b64c32df973cc15f689de61554ec48.svg";